<template>
  <message-view
    :title="title"
    :message="message"
    class="text-center"
  >
    <template #message>
      <i18n
        id="view-message"
        path="redeemed.message"
        tag="h4"
      >
        <span v-html="name" />
        <!-- eslint-disable vue/multiline-html-element-content-newline -->
        <router-link :to="redemptionHistoryRoute">{{
          $t('redemption-history-title')
        }}</router-link>
        <a
          :href="helpLink"
          target="_blank"
          rel="noopener"
        >{{
          $t('help-center')
        }}</a>
      </i18n>
    </template>
    <template #reference-id>
      <parent-reference-line-item-id tag="h2" />
    </template>
  </message-view>
</template>

<script>
import MessageView from './shared/MessageView'
import ParentReferenceLineItemId from '@/components/shared/ParentReferenceLineItemId'
import { REDEMPTION_HISTORY_ROUTE } from '@/router/routes/route-names'

export default {
  name: 'RedeemedView',
  components: {
    MessageView,
    ParentReferenceLineItemId
  },
  props: {
    isPromoLink: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    title () {
      return this.$t('redeemed.title', { name: this.name })
    },
    message () {
      return this.$t('redeemed.message', { name: this.name })
    },
    name () {
      return this.isPromoLink
        ? this.$t('promo-link')
        : `${this.$t('reward-link')}<sup>&reg;</sup>`
    },
    helpLink () {
      return process.env.VUE_APP_KNOWLEDGE_BASE_URL
    },
    redemptionHistoryRoute () {
      return { name: REDEMPTION_HISTORY_ROUTE }
    }
  }
}
</script>
